// Who is signed in, shared by the layout and the pages.
import { ref } from 'vue'
import { api, type Me } from './api'

export const me = ref<Me | null>(null)

export async function loadMe() {
  me.value = await api.get<Me>('/me')
  return me.value
}

export async function signOut() {
  await api.post('/logout').catch(() => undefined)
  me.value = null
}
